import { ExposedAsset } from "./types";

/**
 * Type guard to check if a row has a cases property
 */
export function isAffectedAsset(
  row: Partial<ExposedAsset>,
): row is ExposedAsset {
  return row?.isAffectedAsset === true;
}
